import { render, staticRenderFns } from "./Amenidades.vue?vue&type=template&id=291c8e01&scoped=true&"
import script from "./Amenidades.vue?vue&type=script&lang=js&"
export * from "./Amenidades.vue?vue&type=script&lang=js&"
import style0 from "./Amenidades.vue?vue&type=style&index=0&id=291c8e01&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291c8e01",
  null
  
)

export default component.exports